export default __webpack_public_path__ + "static/pragicts-secops-services-secops-ab8fe4b26434c63bc1b9cb4e0f765eb3.jpg";